import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => {
  const textMaxWidth = theme.spacing(50);
  return {
    box: {
      padding: theme.typography.pxToRem(15),
      textAlign: 'left',
      borderBottom: `1px solid ${theme.evPalette.charcoal['500']}`,
      '&:hover': {
        backgroundColor: theme.evPalette.charcoal['100'],
      },
    },
    textBox: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    notificationText: {
      maxWidth: textMaxWidth,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(18),
      color: theme.evPalette.charcoal['800'],
      '& p': {
        margin: '0px',
      },
    },
    notitfactionClearButton: {
      padding: 0,
      marginLeft: theme.spacing(1),
      alignSelf: 'self-start',
    },
    clearIcon: {
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
      strokeWidth: '0',
      fill: theme.evPalette.charcoal['900'],
      stroke: theme.evPalette.charcoal['900'],
    },
  };
});
